export default {
  html: {
    title: 'Esqueci a Senha'
  },
  title: 'Esqueceu sua senha?',
  description: 'Para recuperar sua senha é simples! Informe seu e-mail no campo abaixo e receba os próximos passos por email.'
}
